const hip = require('./exam_types/hip/prompts');
const knee = require('./exam_types/knee/prompts');
const shoulder = require('./exam_types/shoulder/prompts');
const hand_elbow = require('./exam_types/hand_elbow/prompts');
const foot_ankle = require('./exam_types/foot_ankle/prompts');
const spine = require('./exam_types/spine/prompts');

const all_prompts = {
  hip: {
    label: 'Hip',
    meta: {
      link: 'https://www.myorthopedicproblem.com/hip'
    },
    prompts: hip
  },
  knee: {
    label: 'Knee',
    meta: {
      link: 'https://www.myorthopedicproblem.com/knee'
    },
    prompts: knee
  },
  shoulder: {
    label: 'Shoulder',
    meta: {
      link: 'https://www.myorthopedicproblem.com/shoulder'
    },
    prompts: shoulder
  },
  hand_elbow: {
    label: 'Hand & Elbow',
    meta: {
      link: 'https://www.myorthopedicproblem.com/hand-elbow'
    },
    prompts: hand_elbow
  },
  foot_ankle: {
    label: 'Foot & Ankle',
    meta: {
      link: 'https://www.myorthopedicproblem.com/foot-ankle'
    },
    prompts: foot_ankle
  },
  spine: {
    label: 'Spine',
    meta: {
      link: 'https://www.myorthopedicproblem.com/spine'
    },
    prompts: spine
  }
}


const c_hip = require('./exam_types/hip/conditions');
const c_knee = require('./exam_types/knee/conditions');
const c_shoulder = require('./exam_types/shoulder/conditions');
const c_hand_elbow = require('./exam_types/hand_elbow/conditions');
const c_foot_ankle = require('./exam_types/foot_ankle/conditions');
const c_spine = require('./exam_types/spine/conditions');

const all_conditions = {
  hip: {
    label: "Hip",
    link: "https://www.myorthopedicproblem.com/hip",
    conditions: c_hip
  },
  knee: {
    label: "Knee",
    link: "https://www.myorthopedicproblem.com/knee",
    conditions: c_knee
  },
  shoulder: {
    label: "Shoulder",
    link: "https://www.myorthopedicproblem.com/shoulder",
    conditions: c_shoulder
  },
  hand_elbow: {
    label: "Hand & Elbow",
    link: "https://www.myorthopedicproblem.com/hand-elbow",
    conditions: c_hand_elbow
  },
  foot_ankle: {
    label: "Foot & Ankle",
    link: "https://www.myorthopedicproblem.com/foot-ankle",
    conditions: c_foot_ankle
  },
  spine: {
    label: "Spine",
    link: "https://www.myorthopedicproblem.com/spine",
    conditions: c_spine
  }
}



module.exports = {
  all_prompts,
  all_conditions
}
